import { ZustandBannersStore } from './types';

export const getBannersSelector = (store: ZustandBannersStore) => store.banners;

export const setBannersAction = (store: ZustandBannersStore) =>
  store.setBanners;
